
export class Theme {
  primary_color: string;
  primary_border: string;
  background_color: string;
  background_color_2: string;
  main_text_color: string;
  blue_text_color: string;
  purple_text_color: string;
  grey_text_color: string;
  white_gray_color: string;
  purple_hover_color: string;
  report_row_hover_color: string;
  btn_color: string;
  btn_boder: string;
  section_header_color: string;
  section_header_hover_color: string;
  div_boder: string;
  override: string;
  data_selected: string;
  dropdown_border_bottom_color: string;
  avatar_background_color: string;
  avatar_text_color: string;
  avatar_border: string;
  tab_item: string;
  active_tab_color: string;
  active_tab_border: string;

  input_background: string;
  input_disabled: string;
  input_border: string;
  input_active_box_shadow: string;
  input_active_border: string;
  quill_editor_border: string;
  input_data_border: string;
  progressbar_background: string;
  progressbar_border: string;
}
